import React from "react";
import { Wrench } from "lucide-react";
import { useMaintenance } from "./MaintenanceProvider";

const when = (value) =>
  value
    ? new Date(value).toLocaleString("en-US", {
        dateStyle: "medium",
        timeStyle: "short",
      })
    : "";

export default function MaintenanceNotice() {
  const { status } = useMaintenance();
  const upcoming = status?.upcoming_window;
  if (!upcoming?.starts_at || status?.active) return null;

  return (
    <div
      className="border-b px-6 py-3"
      style={{ background: "#EDF4EF", borderColor: "var(--border-strong)" }}
      data-testid="maintenance-upcoming-notice"
      role="status"
    >
      <div className="mx-auto flex max-w-[1400px] items-start gap-3 text-sm lg:px-4">
        <Wrench size={16} className="mt-0.5 shrink-0" style={{ color: "var(--ink)" }} />
        <p style={{ color: "var(--ink)" }} data-testid="maintenance-upcoming-notice-text">
          Scheduled maintenance begins {when(upcoming.starts_at)}. {upcoming.notice}
        </p>
      </div>
    </div>
  );
}